// extracted by mini-css-extract-plugin
export var modal = "_bs-0";